import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { ResearchUnitRepository } from '@/domain/research-unit/ResearchUnitRepository';
import { ResearchUnitDataset, toResearchUnitDataset } from '@/primary/template-sidebar/research-unit-filter/ResearchUnitDataset';
import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';
import { Store } from '@/primary/store/Store';
import { ComponentState } from '@/primary/ComponentState';
import { Logger } from '@/domain/Logger';

@Component
export default class ResearchUnitFilterComponent extends Vue {
  @Inject()
  private researchUnitRepository!: () => ResearchUnitRepository;

  @Inject()
  private store!: () => Store;

  @Inject()
  private globalWindow!: () => Window;

  @Inject()
  private logger!: () => Logger;

  researchUnitFilter?: number;
  state = ComponentState.PENDING;

  get researchUnits(): ResearchUnit[] {
    return this.store().getFilteredResearchUnits();
  }

  get researchUnitDatasets(): ResearchUnitDataset[] {
    return this.researchUnits.map(toResearchUnitDataset);
  }

  created(): void {
    this.setResearchUnitFilterFromURL();
    this.researchUnitRepository()
      .list()
      .then(researchUnits => this.fromDomain(researchUnits))
      .catch(error => this.handleListResearchUnitError(error));
  }

  setResearchUnitFilterFromURL(): void {
    const researchUnitInURL = /^#\/\?ur=\d{1,5}$/.test(this.globalWindow().location.hash);
    this.researchUnitFilter = researchUnitInURL ? parseInt(this.globalWindow().location.hash.match(/^#\/\?ur=(\d{1,5})$/)![1]) : undefined;
    this.store().saveResearchUnitFilter(this.researchUnitFilter);
  }

  fromDomain(researchUnits: ResearchUnit[]): void {
    this.store().saveResearchUnits(researchUnits);
    this.state = ComponentState.SUCCESS;
  }

  onChangeResearchUnit(researchUnitKey: string): void {
    const researchUnitId = researchUnitKey === 'all' ? undefined : parseInt(researchUnitKey);
    this.globalWindow().location.hash = researchUnitId ? `/?ur=${researchUnitId}` : '';
    this.store().saveResearchUnitFilter(researchUnitId);
  }

  private handleListResearchUnitError(error: Error) {
    this.logger().error('Fail to list research unit', error);
    this.state = ComponentState.ERROR;
  }

  @Watch('researchUnits')
  researchUnitsWatcher() {
    this.researchUnitFilter = undefined;
    this.globalWindow().location.hash = '';
    this.store().saveResearchUnitFilter(undefined);
  }
}
